<template>
  <div class="handle-payment-slow">
    <div class="top-info d-flex justify-content-between flex-wrap mb-4">
      <div class="info-item">
        <span>Khách hàng: <b>{{ data.hoc_vien || '--' }}</b></span>
      </div>

      <div class="info-item">
        <span>Tháng thanh toán: <b>{{ getMonthDeadPayment(data.thoi_han_tra) || '--' }}</b></span>
      </div>

      <div class="info-item">
        <span>Số tiền cần thanh toán: <b>{{ data.so_tien_tra_gop | formatVND }}</b></span>
      </div>
    </div>

    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        class="handle-form"
    >
      <div class="row">

        <div class="col-md-4">
          <p>Lần xử lý <span class="text-danger">*</span></p>
            <el-input :value="'Lần '+ `${data.so_lan_xu_ly_tra_cham + 1}`" disabled />
        </div>

        <div class="col-md-4">
          <p>Kết quả xử lý <span class="text-danger">*</span></p>

          <el-select
                v-model="form.result"
                class="w-100"
                placeholder="Chọn kết quả xử lý"
                clearable
            >
              <el-option
                  v-for="item in resultOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
        </div>

        <div class="col-md-4" v-if="['callback', 'no_answer'].includes(form.result)">
          <p>Thời gian gọi lại <span class="text-danger">*</span></p>
            <el-date-picker
                v-model="form.callback_time"
                class="w-100"
                type="datetime"
                placeholder="Chọn thời gian gọi lại"
                format="dd/MM/yyyy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
        </div>

        <div class="col-md-4" v-if="form.result === 'request_extension'">
          <p>Thời gian thanh toán mới <span class="text-danger">*</span></p>
            <el-date-picker
                v-model="form.new_payment_time"
                class="w-100"
                type="datetime"
                placeholder="Chọn thời gian thanh toán mới"
                format="dd/MM/yyyy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
            />
        </div>
      </div>

      <div class="row" v-if="form.result === 'cancel_contract'">
        <div class="col-12">
          <el-form-item label="Lý do hủy hợp đồng" prop="cancel_reason">
            <el-input
                v-model.trim="form.cancel_reason"
                type="textarea"
                :rows="4"
                placeholder="Nhập lý do hủy hợp đồng"
                maxlength="200"
                show-word-limit
            />
          </el-form-item>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <el-form-item label="Ghi chú" prop="note">
            <el-input
                v-model="form.note"
                type="textarea"
                :rows="6"
                placeholder="Nhập ghi chú"
                maxlength="1000"
                show-word-limit
            />
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="d-flex justify-content-end mt-4">
      <el-button @click="$emit('close')" size="small" style="background-color: #CACACA" class="rounded" >Hủy bỏ</el-button>
      <el-button  @click="handleSubmit" size="small" class="text-white rounded" style="background-color: #5D04B0" :loading="loading" :disabled="loading">Xác nhận</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {GET_RESULT_OPTION, HANDLE_SLOW_PAYMENT} from "../../../../core/services/store/citime/citime.module";

export default {
  name: "dialog-handle-payment-slow",

  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    is_show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      resultOptions: [],
      form: {
        result: '',
        callback_time: '',
        new_payment_time: '',
        cancel_reason: '',
        note: ''
      }
    };
  },

  computed: {
    rules() {
      return {
        result: [
          { required: true, message: 'Vui lòng chọn kết quả xử lý', trigger: 'change' }
        ],
      };
    }
  },



  watch: {
    is_show: {
      handler(newVal) {
        if (!newVal) {
          this.form.result = '';
          this.form.callback_time = '';
          this.form.new_payment_time = '';
          this.form.cancel_reason = '';
          this.form.note = '';
        }
        if(newVal && !this.resultOptions.length > 0) {
          console.log('zo')
            this.getResultOptions();
        }
      },
      immediate: true
    }
  },

  methods: {
    getMonthDeadPayment(deadline) {
      if (!deadline) return '';

      const m = moment(deadline, [
        'DD/MM/YYYY',
        'DD/MM/YYYY HH:mm:ss',
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        moment.ISO_8601
      ], true);

      return m.isValid() ? m.format('MM/YYYY') : '';
    },

    formatDateTime(value) {
      if (!value) return '';

      const m = moment(value, [
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD',
        'DD/MM/YYYY HH:mm:ss',
        'DD/MM/YYYY',
        moment.ISO_8601
      ], true);

      return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : value;
    },

    getSubmitPayload() {
      return {
        payment_id: this.data.id || null,
        result: this.form.result,
        callback_at: this.form.callback_time || null,
        new_payment_date: this.form.new_payment_time || null,
        cancel_reason: this.form.cancel_reason ? this.form.cancel_reason.trim() : null,
        note: this.form.note ? this.form.note.trim() : ''
      };
    },

    async handleSubmit() {
        this.loading = true;

        const payload = this.getSubmitPayload();

        try {
          const res = await this.$store.dispatch(HANDLE_SLOW_PAYMENT, payload);

          this.$notify({
            title: 'Success',
            message: res?.message || 'Xử lý lỗi thanh toán thành công!',
            type: 'success'
          });

          this.form.amount = '';
          this.$emit('close');
          this.$emit('reload');
        } catch (e) {
          this.$notify.error({
            title: 'Có lỗi xảy ra!',
            message: e?.data?.message || 'Xử lý lỗi thanh toán thất bại!'
          });
        } finally {
          this.loading = false;
        }
    },

    getResultOptions() {
      this.$store.dispatch(GET_RESULT_OPTION).then((res) => {
        this.resultOptions = res.data
      }).catch((e) => {
        this.$notify.error({
          title: 'Có lỗi xảy ra!',
          message: e?.data?.message || 'Lấy thông tin kết quả xử lý thất bại!'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-payment-slow {
  .top-info {
    gap: 12px;

    .info-item {
      margin-bottom: 8px;
      font-size: 14px;
    }
  }

  .history-block {
    padding: 16px;
    border-radius: 8px;
    background: #f7f8fa;
    border: 1px solid #ebeef5;
  }

  .history-title {
    font-weight: 700;
    margin-bottom: 12px;
    font-size: 15px;
  }

  .history-item {
    padding: 12px 0;
    border-bottom: 1px dashed #dcdfe6;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .history-item__head {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .history-item__body {
    font-size: 13px;
    line-height: 1.8;
    color: #606266;
  }

  .footer-action {
    gap: 12px;
  }
}
</style>